// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ib_L","col":"styles_col__tJ0hx","actions":"styles_actions__1oiGA","conflict":"styles_conflict__3TKXV"};